import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

const DESCRIPTIONS = ['Visitors Premium Monthly', 'Deliveries Standard Monthly', 'Rooms Standard Monthly'];

export default Factory.extend({
  amount: () => faker.number.int(40000),
  description: () => faker.helpers.arrayElement(DESCRIPTIONS),
  discountAmount: () => faker.number.int(20000),
  entityType: 'plan',
  quantity: 1,
  unitAmount: () => faker.number.int(30000),
  discounts: () => [],
});
